// removed by extract-text-webpack-plugin
module.exports = {"deleteIcon":"index__deleteIcon___2n9mX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DeleteConfirmBtn/index.less
// module id = 1043
// module chunks = 3